import * as styles from "./ClosureWeeksPanel.css";

import { type JSX, useState } from "react";

import {
  Field,
  FieldContent,
  FieldLabel,
} from "@frontend/components/atoms/Field";
import { Panel } from "@frontend/components/atoms/Panel";
import {
  YearPicker,
  YearPickerContent,
  YearPickerTrigger,
  YearPickerValue,
} from "@frontend/components/atoms/YearPicker";
import { Trans } from "@lingui/react/macro";

import { useClosureWeeks } from "../hooks/useClosureWeeks";
import { ClosureWeeksBody } from "./ClosureWeeksBody";

export type ClosureWeeksPanelProps = {
  projectId: number;
  readOnly?: boolean;
};

export function ClosureWeeksPanel({
  projectId,
  readOnly = false,
}: ClosureWeeksPanelProps): JSX.Element {
  const [year, setYear] = useState(new Date().getFullYear());

  useClosureWeeks({ projectId, year });

  return (
    <div className={styles.panel}>
      <Panel overflow="visible">
        <div className={styles.content}>
          {readOnly ? (
            <p className={styles.readOnly}>
              <Trans>
                No contract is running on this subscription, so the weeks it
                closed are shown as they were saved and cannot be changed.
              </Trans>
            </p>
          ) : null}

          <ClosureWeeksBody
            readOnly={readOnly}
            yearField={
              <Field orientation="horizontal" className={styles.year}>
                <FieldLabel>
                  <Trans>Year</Trans>
                </FieldLabel>

                <FieldContent>
                  <YearPicker
                    value={year}
                    onValueChange={setYear}
                    min={2000}
                    max={2100}
                  >
                    <YearPickerTrigger>
                      <YearPickerValue />
                    </YearPickerTrigger>

                    <YearPickerContent />
                  </YearPicker>
                </FieldContent>
              </Field>
            }
          />
        </div>
      </Panel>
    </div>
  );
}
